import { oneOf } from "prop-types";
import { ORDER_STATUSES_LIST } from "../../constants";

const OrderStatusType = oneOf(ORDER_STATUSES_LIST);

export default OrderStatusType;
